<template>
    <div class="p-5 darker accountsTab">
        <div class="w-100 mb-2 text-right">
            <!-- <input type="button" value="Create Account" class="btn widest ml-auto" > -->
            <button class="btn widest ml-auto" @click="addAccount">Create Account</button>
        </div>

        <div class="col-sm-12 text-center" v-if="getIsLoadingSupplierAccounts">
            <loader></loader>
        </div>

        <div class="col-sm-12 mb-4" v-else>
            <list class="w-100" :header="header" :body="body" :rows="userAccounts" :actions="actions"></list>
        </div>

    </div>
</template>

<script>
    import extendedVSelect from '@/extends/vue-select'
    import {mapGetters, mapActions} from 'vuex'
    import List from '@/tools/list/baseList'
    import Loader from '@/tools/loaders/loader1'
    import AvatarLoader from '@/tools/avatarLoader'

    export default {
        data: function() {
            return {
                header: {
                    selection: {
                        active: false,
                        event: function(event) {}
                    },
                    list: {
                        'avatar': 'Avatar',
                        'name': 'Name',
                        'email': 'Email',
                        'status': 'Status',
                        'type': 'Access Type'
                    },
                    customClassCell: true,
                    customCellClass: {
                        avatar: 'avatarRowWidth text-center'
                    }
                },
                body: {
                    selection: {
                        active: false,
                        event: function(event) {}
                    },
                    customRowEvent: this.openAccountDetails,
                    customClassCell: {
                        avatar: 'text-center'
                    },
                    customCells: {
                        avatar: function(row) {
                            // return row.imagePhoto
                            if(row.imagePhoto){
                                return '<div class="avatarHolder radius-circle d-inline-block" style="background-image: url(\''+row.imagePhoto+'\');">'
                            }
                            return '<i class="fas fa-user-circle fa-5x dark mr-0"></i>'
                        },
                        name: function(row) {
                            return row.name
                        },
                        email: function(row) {
                            return row.email
                        },
                        status: function(row) {
                            // return row.isActive? '<span class="radius-normal lightest bg-color-3 fs-smaller px-2 py-1 w-100">Active</span>' : '<span class="radius-normal lightest bg-color-6 fs-smaller px-2 py-1 w-100">Inactive</span>'
                            return row.isActive? 'Active' : 'Inactive'
                        },
                        type: function(row) {
                            switch (row.userAccountTypeDefault.accessType) {
                                case 1:
                                    // return '<span class="radius-normal lightest bg-color-3 fs-smaller px-2 py-1 w-100">Admin</span>'
                                    return 'Admin'
                                    break;
                                case 2:
                                    // return '<span class="radius-normal lightest bg-color-3 fs-smaller px-2 py-1 w-100">Admin</span>'
                                    return 'Restricted'
                                    break;
                                case 3:
                                    // return '<span class="radius-normal lightest bg-color-3 fs-smaller px-2 py-1 w-100">Admin</span>'
                                    return 'Main Supervisor'
                                    break;
                                case 4:
                                    // return '<span class="radius-normal lightest bg-color-3 fs-smaller px-2 py-1 w-100">Admin</span>'
                                    return 'Agent Supervisor'
                                    break;
                                case 5:
                                    // return '<span class="radius-normal lightest bg-color-3 fs-smaller px-2 py-1 w-100">Admin</span>'
                                    return 'Marketing Supervisor'
                                    break;
                                case 6:
                                    // return '<span class="radius-normal lightest bg-color-3 fs-smaller px-2 py-1 w-100">Admin</span>'
                                    return 'My Team Supervisor'
                                    break;
                                case 7:
                                    // return '<span class="radius-normal lightest bg-color-3 fs-smaller px-2 py-1 w-100">Admin</span>'
                                    return 'Viewer'
                                    break;
                                default:
                                    // return '<span class="radius-normal lightest bg-color-5 fs-smaller px-2 py-1 w-100">Basic</span>'
                                    return 'Basic'
                            }
                        },
                    },
                },
                actions: {
                    label : 'Actions',
                    list: [],
                }
            }
        },
        created: function () {
            this.downloadSupplierAccounts()
        },
        computed: {
            ...mapGetters([
                'getSupplierAccounts',
                'getIsLoadingSupplierAccounts',
                'getUserAccessTypes'
            ]),
            userAccounts: function () {
                return this.getSupplierAccounts
            },
            teste: function () {
                return 'asd'
            }
        },
        methods:{
            ...mapActions([
                'downloadSupplierAccounts',
                'setSupplierAccountAsSelected',
                'clearSelectedSupplierAccount',
                'openModal'
            ]),
            addAccount: function () {
                this.clearSelectedSupplierAccount()
                this.openModal('supplierAccountModal')
            },
            openAccountDetails: function(accountData) {
                this.setSupplierAccountAsSelected(JSON.parse(JSON.stringify(accountData)))
                this.openModal('supplierAccountModal')
            }
        },
        components:{
            vSelect: extendedVSelect,
            List,
            Loader,
            AvatarLoader
        }
    }
</script>

<style scoped lang="scss">

</style>

<style lang="scss">
.accountsTab{
    .avatarRowWidth{
        width: 100px;
    }
    .avataHolder{
        width: 62px;
        height: 62px;
    }
    .avatarHolder{
        width: 62px;
        height: 62px;
        background-position: center;
        background-size: cover;
    }
}
</style>



// WEBPACK FOOTER //
// TabAccounts.vue?34b71a42